"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var KsysRequest_1 = require("../KsysRequest");

var GetTheme =
/** @class */
function (_super) {
  __extends(GetTheme, _super);

  function GetTheme() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getExplicitEndpoint = function () {
      return '/applicationManager/getTheme';
    };

    _this.getExplicitMethod = function () {
      return 'GET';
    };

    return _this;
  }

  Object.defineProperty(GetTheme.prototype, "endpointConfiguration", {
    get: function get() {
      return this.getEndpointConfiguration("applicationManager", "GetTheme");
    },
    enumerable: true,
    configurable: true
  });
  return GetTheme;
}(KsysRequest_1.KsysRequest);

exports.GetTheme = GetTheme;